import { motion } from 'framer-motion';
import { Play, X } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import SectionTitle from '@/components/ui/SectionTitle';

export default function CoffeeTourSection() {
  const { t } = useTranslation();
  const [videoOpen, setVideoOpen] = useState(false);

  const images = [
    { src: '/images/finca/cabana.jpg', alt: 'Cabaña Finca Los Sauces' },
    { src: '/images/video-bg.jpg', alt: 'Tour video thumbnail', isVideo: true },
    { src: '/images/finca/tour.jpg', alt: 'Tour Finca Los Sauces' },
  ];

  return (
    <section id="coffeetour" className="relative pt-20 pb-8 md:pt-28 md:pb-10 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionTitle title={t('tour.title')} subtitle={t('tour.gallerySubtitle')} />

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {images.map((img, i) => (
            <motion.div
              key={img.src}
              className="relative rounded-xl overflow-hidden shadow-lg group aspect-[4/3]"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.6, delay: i * 0.12 }}
            >
              <img
                src={img.src}
                alt={img.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                loading="lazy"
              />
              {img.isVideo && (
                <button
                  onClick={() => setVideoOpen(true)}
                  className="absolute inset-0 flex items-center justify-center"
                  aria-label={t('mission.play')}
                >
                  <div className="w-14 h-14 bg-white/90 rounded-full flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                    <Play className="w-6 h-6 text-coffee-700 fill-current ml-1" />
                  </div>
                </button>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          className="mt-10 md:mt-14 max-w-3xl mx-auto text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6 }}
        >
          <p className="text-lg md:text-xl text-coffee-800 leading-relaxed">
            {t('tour.description')}
          </p>
        </motion.div>
      </div>

      {videoOpen && (
        <>
          <div
            className="fixed inset-0 bg-black/80 backdrop-blur-sm z-[70]"
            onClick={() => setVideoOpen(false)}
          />
          <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
            <div className="relative w-full max-w-4xl aspect-video rounded-2xl overflow-hidden shadow-2xl bg-black">
              <button
                onClick={() => setVideoOpen(false)}
                className="absolute top-3 right-3 z-10 p-2 bg-black/50 hover:bg-black/70 rounded-full text-white transition-colors"
                aria-label="Cerrar video"
              >
                <X className="w-5 h-5" />
              </button>
              <video
                className="w-full h-full"
                src="/images/sauces_webm.webm"
                controls
                autoPlay
                playsInline
              />
            </div>
          </div>
        </>
      )}
    </section>
  );
}
